<template>
  <div class="no">
    <p>NOT IMPLEMENTED YET!</p>
  </div>
</template>

<script>
export default {
  name: 'SurveyExports',

  props: {
    survey_status: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
.no {
  color: red;
}
</style>
